import React from 'react';

const AddressWrapperContext = React.createContext();

export default AddressWrapperContext;
